import * as React from 'react'
import { Container, Grid2 } from '@mui/material'
import dayjs from 'dayjs'
import { Page, Text, View, Document, Image } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import ModernNavbar from '../setup/ModernNavbar';
import Footer from '../setup/Footer';
import { useDispatch, useSelector } from 'react-redux';
import '../../services/GlobalVariables'
import { useLocation, useNavigate } from 'react-router-dom';
import { getIndividualEomployees } from '../../features/PayrollManagement/employeeSlice';
import Loading from '../../BuiltInComponent/Loading'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const styleHeading = () => ({
    textAlign: 'center',
    marginTop: 20,
    marginRight: 50,
    marginLeft: 50,
    backgroundColor: '#565656',
    color: 'white',
    padding: 5,
    borderRadius: 10,
    fontWeight: 'bold',          // was '900' (string)
    fontSize: 25                 // was '25px'
});

const styleMasterData = (width, textAlign) => ({
    width,
    textAlign,
    fontSize: 10,                // was '10px'
    fontWeight: 'bold'           // was 'bolder'
});

const styleRowTop = (width) => ({
    width,
    fontSize: 10,
    backgroundColor: 'grey',
    color: 'white',
    borderWidth: 1,              // was border: '1px solid white'
    borderColor: 'white',
    padding: 2
});

const styleRowDetail = (width) => ({
    width,
    fontSize: 10,
    borderWidth: 1,              // was border: '1px solid black'
    borderColor: 'black',
    padding: 2
});

export default function EmployeeDetails() {

    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { user } = useSelector(state => state.auth)
    const { indEmployee, isLoading } = useSelector(state => state.emp)

    React.useEffect(() => {
        const passedEmpID = location.state?.empID || ''
        dispatch(getIndividualEomployees(passedEmpID))
    }, [location.state?.empID, dispatch]);

    const eduData = [
        // { eduID: 1, edudegree: 'M.S.C.S', eduUni: 'Iqra University', eduYear: '2017', eduGrade: 'First Division', eduRollNo: '123456' },
        // { eduID: 2, edudegree: 'B.S.C.S', eduUni: 'Virtual University', eduYear: '2013', eduGrade: 'First Division', eduRollNo: '123456' },
        // { eduID: 3, edudegree: 'F.C.S', eduUni: 'Shipowner College', eduYear: '2008', eduGrade: 'B', eduRollNo: '123456' },
        // { eduID: 4, edudegree: 'H.S.C', eduUni: 'G.B.S.S. No.14', eduYear: '2008', eduGrade: 'B', eduRollNo: '123456' },
    ];

    const expData = [
        // { expID: 1, expComp: 'Silver Rags Private Limited', expDesi: 'General Manager', expFrom: '2020', expTo: '2024', expLastPay: '180000' },
        // { expID: 2, expComp: 'ROPlant.PK', expDesi: 'Chief Accountant', expFrom: '2017', expTo: '2020', expLastPay: '125000' },
        // { expID: 3, expComp: 'Sohairah Associates', expDesi: 'Account Manager', expFrom: '2013', expTo: '2017', expLastPay: '90000' },
    ];

    return (
        <>
            <ModernNavbar />
            <Container>
                <Grid2 container spacing={2}>
                    <Grid2 size={0.5}>
                        <KeyboardBackspaceIcon
                            sx={{
                                fontSize: 30, marginLeft: -1, color: 'white', cursor: 'pointer',
                                backgroundColor: '#1E90FF', padding: 1, borderRadius: 50
                            }}
                            onClick={() => { navigate('/EmployeeList') }} />
                    </Grid2>
                    <Grid2 size={11.5}></Grid2>
                </Grid2>
                {isLoading ? <><Loading /></> :
                    <>
                        <PDFViewer height={880} width={'100%'} style={{ marginTop: 10 }}>
                            <Document title={`Purchase_History_${dayjs(Date.now()).format('DDMMYYYY_hh:mmA')}`}>
                                <Page size="A4">
                                    <View style={{ flexDirection: 'row', marginTop: 10, marginLeft: 10 }}>
                                        <Image style={{ height: 50, width: 50, borderRadius: 50 }} src={user && `${global.SET_API_URL}/images/${user.cmpImage}`} />
                                        <View style={{ marginLeft: 10 }}>
                                            <Text style={{ fontSize: 15 }}>Malted Exports</Text>
                                            <Text style={{ fontSize: 9 }}>Office # 4, 17-C, Ittihad Lane 12, DHA Phase 2 Karachi, Pakistan</Text>
                                            {/* <Text style={{ fontSize: 9 }}>1234-1234567</Text> */}
                                        </View>
                                    </View>

                                    <View style={styleHeading()}>
                                        <Text>Employee Registration Form</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginTop: 15, borderBottomWidth: 2, borderBottomColor: 'black' }}>
                                        <Text style={{ fontSize: 20, marginLeft: 10 }}>Employee Personal Information</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginTop: 10, marginLeft: 10 }}>
                                        <Text style={styleMasterData('50%', 'left')}>{indEmployee && indEmployee.length > 0 && indEmployee[0].empName}</Text>
                                        <Text style={styleMasterData('50%', 'left')}>{indEmployee && indEmployee.length > 0 && indEmployee[0].empFName}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginTop: 5, marginLeft: 10 }}>
                                        <Text style={styleMasterData('50%', 'left')}>{indEmployee && indEmployee.length > 0 && indEmployee[0].empCNIC}</Text>
                                        <Text style={styleMasterData('50%', 'left')}>{indEmployee && indEmployee.length > 0 && indEmployee[0].empContact}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginTop: 5, marginLeft: 10 }}>
                                        <Text style={styleMasterData('50%', 'left')}>E-mail : {indEmployee && indEmployee.length > 0 && indEmployee[0].empEmail}</Text>
                                        <Text style={styleMasterData('50%', 'left')}>Salary : Rs-{indEmployee && indEmployee.length > 0 && indEmployee[0].empSalary}/-</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginTop: 5, marginLeft: 10 }}>
                                        <Text style={styleMasterData('50%', 'left')}>Over Time : {indEmployee && indEmployee.length > 0 && indEmployee[0].empOT ? 'Allowed' : 'Not Allowed'}</Text>
                                        <Text style={styleMasterData('50%', 'left')}>O.T. Rate : {indEmployee && indEmployee.length > 0 && indEmployee[0].empOTRate}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginTop: 5, marginLeft: 10 }}>
                                        <Text style={styleMasterData('50%', 'left')}>Joining : {indEmployee && indEmployee.length > 0 && dayjs(indEmployee[0].enpDate).format('YYYY-MM-DD')}</Text>
                                        <Text style={styleMasterData('50%', 'left')}>Probation Ends : {indEmployee && indEmployee.length > 0 && dayjs(indEmployee[0].empProbEnds).format('YYYY-MM-DD')} (After Prob Inc 20%)</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginTop: 5, marginLeft: 10 }}>
                                        <Text style={styleMasterData('50%', 'left')}>Emergency Cont Pers : {indEmployee && indEmployee.length > 0 && indEmployee[0].empEmergencyCP}</Text>
                                        <Text style={styleMasterData('50%', 'left')}>Emergency Cont Pers Cont : {indEmployee && indEmployee.length > 0 && indEmployee[0].empEmergencyCPC}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginTop: 5, marginLeft: 10 }}>
                                        <Text style={styleMasterData('100%', 'left')}>Address : {indEmployee && indEmployee.length > 0 && indEmployee[0].empAddress}</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginTop: 15, marginLeft: 10, textDecoration: 'underline' }}>
                                        <Text style={{ fontSize: 20 }}>Employee Education</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginLeft: 10, marginRight: 10, marginTop: 10 }}>
                                        <Text style={styleRowTop('15%')}>Degree</Text>
                                        <Text style={styleRowTop('45%')}>University</Text>
                                        <Text style={styleRowTop('15%')}>Passing Year</Text>
                                        <Text style={styleRowTop('15%')}>Grade</Text>
                                        <Text style={styleRowTop('20%')}>Roll No</Text>
                                    </View>

                                    {eduData.map((row) => (
                                        <View key={row.eduID} style={{ flexDirection: 'row', marginLeft: 10, marginRight: 10 }}>
                                            <Text style={styleRowDetail('15%')}>{row.edudegree}</Text>
                                            <Text style={styleRowDetail('45%')}>{row.eduUni}</Text>
                                            <Text style={styleRowDetail('15%')}>{row.eduYear}</Text>
                                            <Text style={styleRowDetail('15%')}>{row.eduGrade}</Text>
                                            <Text style={styleRowDetail('20%')}>{row.eduRollNo}</Text>
                                        </View>
                                    ))}

                                    <View style={{ flexDirection: 'row', marginTop: 15, marginLeft: 10, textDecoration: 'underline' }}>
                                        <Text style={{ fontSize: 20 }}>Employee Experience</Text>
                                    </View>

                                    <View style={{ flexDirection: 'row', marginLeft: 10, marginRight: 10, marginTop: 10 }}>
                                        <Text style={styleRowTop('45%')}>Company</Text>
                                        <Text style={styleRowTop('20%')}>Designation</Text>
                                        <Text style={styleRowTop('10%')}>From</Text>
                                        <Text style={styleRowTop('10%')}>To</Text>
                                        <Text style={styleRowTop('15%')}>Last Salary</Text>
                                    </View>

                                    {expData.map((row) => (
                                        <View key={row.expID} style={{ flexDirection: 'row', marginLeft: 10, marginRight: 10 }}>
                                            <Text style={styleRowDetail('45%')}>{row.expComp}</Text>
                                            <Text style={styleRowDetail('20%')}>{row.expDesi}</Text>
                                            <Text style={styleRowDetail('10%')}>{row.expFrom}</Text>
                                            <Text style={styleRowDetail('10%')}>{row.expTo}</Text>
                                            <Text style={styleRowDetail('15%')}>{row.expLastPay}</Text>
                                        </View>
                                    ))}

                                </Page>
                            </Document>
                        </PDFViewer>
                    </>
                }
            </Container>
            <Footer />
        </>
    )
}
